import React from "react"
import { string } from "prop-types"

const Period = ({ startDate, endDate, period }) => {
  if (!(period && startDate && endDate)) return null

  const diff = endDate.diff(startDate, "days") + 1
  return (
    <div className="DateRagePeriod">
      <p>Período:</p>
      <p> {diff} dias </p>
    </div>
  )
}

Period.propTypes = {
  startDate: string,
  endDate: string,
  period: string
}

export default Period



// WEBPACK FOOTER //
// ./src/components/DateRangePicker/components/Period.js